import React from "react";
import Icon from "components/AppIcon";

const OrderBook = ({ orderBook, currentPrice }) => {
  const maxAskSize = Math.max(...orderBook?.asks?.map(a => a?.size));
  const maxBidSize = Math.max(...orderBook?.bids?.map(b => b?.size));

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-5">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="BookOpen" size={16} color="var(--color-primary)" />
        <span className="font-heading text-sm font-semibold text-foreground">Order Book</span>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {/* Asks */}
        <div>
          <div className="text-xs font-caption text-muted-foreground uppercase tracking-wider mb-2 text-center">Asks (Sell)</div>
          <div className="space-y-0.5">
            {orderBook?.asks?.slice()?.reverse()?.map((ask, i) => (
              <div key={i} className="relative flex items-center justify-between px-2 py-1 rounded text-xs font-mono overflow-hidden">
                <div className="absolute inset-0 rounded" style={{ background: `rgba(239,68,68,${(ask?.size / maxAskSize) * 0.15})`, right: 0 }} />
                <span className="relative z-10" style={{ color: "var(--color-error)" }}>${ask?.price?.toFixed(2)}</span>
                <span className="relative z-10 text-muted-foreground">{ask?.size?.toLocaleString()}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Bids */}
        <div>
          <div className="text-xs font-caption text-muted-foreground uppercase tracking-wider mb-2 text-center">Bids (Buy)</div>
          <div className="space-y-0.5">
            {orderBook?.bids?.map((bid, i) => (
              <div key={i} className="relative flex items-center justify-between px-2 py-1 rounded text-xs font-mono overflow-hidden">
                <div className="absolute inset-0 rounded" style={{ background: `rgba(16,185,129,${(bid?.size / maxBidSize) * 0.15})` }} />
                <span className="relative z-10" style={{ color: "var(--color-success)" }}>${bid?.price?.toFixed(2)}</span>
                <span className="relative z-10 text-muted-foreground">{bid?.size?.toLocaleString()}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Spread */}
      <div className="mt-3 pt-3 border-t border-border flex items-center justify-between">
        <span className="text-xs text-muted-foreground font-caption">Spread</span>
        <span className="text-xs font-mono font-semibold" style={{ color: "var(--color-accent)" }}>
          ${(orderBook?.asks?.[0]?.price - orderBook?.bids?.[0]?.price)?.toFixed(2)}
        </span>
        <span className="text-xs font-mono font-bold" style={{ color: "var(--color-primary)" }}>
          ${currentPrice?.toFixed(2)}
        </span>
      </div>
    </div>
  );
};

export default OrderBook;